import { pdpaApi } from "@api";
import { ArrowLeft, StyledPrivacy } from "@components";
import { IClientPdpa } from "@interfaces";
import { selectMerchant } from "@redux";
import Parser from "html-react-parser";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
export const PagePurpose = () => {
    const [clientPdpa, setClientPdpa] = useState<IClientPdpa>();
    const history = useHistory();
    const { themes } = useSelector(selectMerchant);
    const { id } = useParams<{ id: string }>();

    useEffect(() => {
        fetchNotice();
    }, []);
    const fetchNotice = async () => {
        const res = await pdpaApi.getPurpose(id || "");
        if (res.data) {
            setClientPdpa(res.data);
        }
    };

    return (
        <StyledPrivacy themeColor={themes?.themeColor!} color={themes?.themeColor!}>
            <header>
                <div className="back-arrow">
                    <ArrowLeft onClick={() => history.goBack()} />
                </div>
                <div className="title-group">
                    <h4>{clientPdpa?.nameForm}</h4>
                    <p>{clientPdpa?.titleForm}</p>
                </div>
            </header>
            <article>{Parser(clientPdpa?.detail || "")}</article>
        </StyledPrivacy>
    );
};
